import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireCJRS: QuestionnaireFlowType = {
    id: FindingAreasEnum.CoronavirusJobRetentionScheme,
    name: getFindingAreaDisplayText(FindingAreasEnum.CoronavirusJobRetentionScheme),
    questions: [
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q1`,
            text: "Did you make a claim under the Coronavirus Job Retention ('furlough') Scheme?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q2`, 
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q2`, 
            text: "Was any professional advice obtained in relation to the claim?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q3A`, 
                no: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q3B`, 
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q3A`, //Note: Q3A and Q3B are the same
            text: "Have you received any correspondence from HMRC regarding the validity of the claim?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q4A`, 
                no: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5B`, 
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q3B`,
            text: "Have you received any correspondence from HMRC regarding the validity of the claim?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q4B`,
                no: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5C`,
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q4A`, 
            text: "Is the matter still outstanding with HMRC?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5A`, 
                no: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5B`, 
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q4B`, //Note: Q4A and Q4B are the same
            text: "Is the matter still outstanding with HMRC?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5D`,
                no: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5B`,
            },
        },


        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5A`, //Q5A and Q5B are the same
            text: "What was the total value of your CJRS claim?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Amber,
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5B`, 
            text: "What was the total value of your CJRS claim?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5C`, //Q5C and Q5D are the same
            text: "What was the total value of your CJRS claim?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Inconclusive
            },
        },
        {
            id: `${FindingAreasEnum.CoronavirusJobRetentionScheme}:Q5D`,
            text: "What was the total value of your CJRS claim?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
               next: ConclusionKeys.Red
            },
        },

    ],
};

export default questionnaireCJRS;